import { render, staticRenderFns } from "./OriginStoryList.vue?vue&type=template&id=7499b827&lang=pug&"
import script from "./OriginStoryList.vue?vue&type=script&lang=ts&"
export * from "./OriginStoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports